import styled, { css } from 'styled-components';

import { size } from '../../layout/helpers';
import { inputPlaceholder } from '../../layout/reset';

interface TextareaProps {
  $hasError?: boolean;
}

export const Textarea = styled.textarea.withConfig({ componentId: 'sc-1v07341-0' })<TextareaProps>`
    ${inputPlaceholder};
    display: block;
    width: 100%;
    height: 150px;
    min-height: 100px;
    max-height: 450px;
    padding: ${size(2)};
    resize: vertical;
    background-color: var(--c-bg-main);
    border: 1px solid var(--c-input-border);
    box-shadow: ${(props) => props.theme.boxShadow.inset};
    border-radius: ${(props) => props.theme.size.borderRadius};
    font-size: var(--font-size-input);
    font-weight: var(--font-weight-regular);
    font-family: var(--font-family);
    -moz-appearance: none;
    -webkit-appearance: none;

    &:focus {
        outline: none;
    }

    &[disabled] {
        opacity: 0.37;
        cursor: not-allowed;
    }

    ${({ $hasError }) =>
      $hasError
        ? css`
                  border-color: var(--c-input-error-border);
              `
        : css`
                  &:focus {
                      border-color: var(--c-input-border-focus);
                  }
              `}
`;
